import { ContentBlock } from '$components/ContentBlock';
import { useFragment } from '$contentful-gql/fragment-masking';
import { textFragment } from '$providers/common';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { IProductSlideContent, ProductSliderType } from './';

export function ProductContent(
  props: IProductSlideContent & HTMLAttributes<HTMLElement>,
) {
  const { className, item, ctas, index, active, type } = props;

  const cardText = useFragment(textFragment, item);
  const typeClasses: Record<ProductSliderType, string> = {
    light: 'text-grey-100',
    dark: 'text-white',
  };

  return (
    <div
      key={index}
      className={cn(
        //'duration-1000 absolute md:top-[50%] md:-mt-[50%] lg:-mt-[25%] mb-6 lg:mb-0 w-full',
        'duration-1000 md:absolute md:top-[50%] md:-mt-[50%] lg:-mt-[25%] mb-6 lg:mb-0 w-full px-4 md:px-0',
        active ? 'opacity-100' : 'opacity-0 absolute',
      )}
    >
      <ContentBlock
        widthLimit={false}
        className={cn(className, typeClasses[type])}
        layout={'left'}
        heading={cardText.title}
        subHeading={cardText.subtitle}
        content={cardText.description}
        button={ctas}
        type={type}
        size={'medium'}
        richText={cardText.richText}
      />
    </div>
  );
}
